import { SessionProvider } from '@context/SessionContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import 'react-quill-new/dist/quill.snow.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import BrowserTelemetryProvider from './observability/BrowserTelemetryProvider';
import { publishReleaseMetadata } from './observability/releaseMetadata';

window.global = window;

publishReleaseMetadata();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 6,
      cacheTime: 1000 * 60 * 60 * 6,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <BrowserTelemetryProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserTelemetryProvider>
    </BrowserRouter>
    {import.meta.env.MODE === 'development' && <ReactQueryDevtools />}
  </QueryClientProvider>,
);
